import React from "react";
import { FaPlus, FaTrash, FaArrowUp, FaArrowDown } from "react-icons/fa";
import { colors, spacing, typography, inputBase, btnSecondary, btnGhost } from "../../../utils/designTokens";

/**
 * Orden del día de una asamblea (alta, edición y asamblea ya realizada):
 * puntos con título y detalle; se agregan, se quitan y se ordenan. Controlado:
 * `puntos` [{id?, titulo, detalle}] y `onChange(puntos)`. `error`: el del
 * servidor o la validación del formulario para el orden del día.
 */
export default function OrdenDelDiaEditor({ puntos, onChange, error }) {
  const setPunto = (i, campo, valor) => onChange(puntos.map((p, j) => (j === i ? { ...p, [campo]: valor } : p)));
  const agregarPunto = () => onChange([...puntos, { titulo: "", detalle: "" }]);
  const quitarPunto = (i) => onChange(puntos.filter((_, j) => j !== i));
  const moverPunto = (i, d) => {
    const j = i + d;
    if (j < 0 || j >= puntos.length) return;
    const lista = [...puntos];
    [lista[i], lista[j]] = [lista[j], lista[i]];
    onChange(lista);
  };
  const label = { fontSize: typography.sizes.sm, color: colors.gray600, fontWeight: 400 };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: spacing[2] }}>
        <h3 style={{ margin: 0, fontSize: typography.sizes.md, color: colors.black, fontWeight: 400 }}>Orden del día</h3>
        <button type="button" style={btnSecondary} className="habitia-btn-secondary" onClick={agregarPunto}>
          <FaPlus /> Agregar punto
        </button>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: spacing[3] }}>
        {puntos.map((p, i) => (
          <div key={p.id || i} style={{ display: "grid", gridTemplateColumns: "32px 1fr auto", gap: spacing[2], alignItems: "start" }}>
            <span style={{ ...label, paddingTop: 10 }}>{i + 1}.</span>
            <div style={{ display: "flex", flexDirection: "column", gap: spacing[2] }}>
              <input
                aria-label={`Título del punto ${i + 1}`}
                type="text"
                maxLength={200}
                className="habitia-input"
                style={inputBase}
                value={p.titulo}
                onChange={(e) => setPunto(i, "titulo", e.target.value)}
                placeholder="Aprobación del balance"
              />
              <textarea
                aria-label={`Detalle del punto ${i + 1}`}
                maxLength={2000}
                rows={2}
                className="habitia-input"
                style={{ ...inputBase, resize: "vertical" }}
                value={p.detalle}
                onChange={(e) => setPunto(i, "detalle", e.target.value)}
                placeholder="Detalle (opcional)"
              />
            </div>
            <div style={{ display: "flex", gap: spacing[1] }}>
              <button type="button" style={btnGhost} className="habitia-btn-ghost" onClick={() => moverPunto(i, -1)} aria-label="Subir punto" disabled={i === 0}><FaArrowUp /></button>
              <button type="button" style={btnGhost} className="habitia-btn-ghost" onClick={() => moverPunto(i, 1)} aria-label="Bajar punto" disabled={i === puntos.length - 1}><FaArrowDown /></button>
              <button type="button" style={btnGhost} className="habitia-btn-ghost" onClick={() => quitarPunto(i)} aria-label="Eliminar punto" disabled={puntos.length === 1}><FaTrash /></button>
            </div>
          </div>
        ))}
      </div>
      {error && (
        <p role="alert" style={{ margin: `${spacing[2]}px 0 0`, fontSize: typography.sizes.sm, color: colors.error }}>
          {error}
        </p>
      )}
    </div>
  );
}
